import { SET_STRIKER_BY_TOURNAMENT } from "../constans"

export const setStrikersByTournament = (strikers)=> dispatch =>{
    dispatch({
        type:SET_STRIKER_BY_TOURNAMENT,
        payload: strikers
    })

}